import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { track } from '@plausible-analytics/tracker';
import { LandingPageProvider } from './LandingPageContext';
import LandingScreenContainer from '../../containers/LandingScreenContainer';

/**
 * LandingConsumerPage — route / et /:parcelId
 * Fournit le LandingPageContext (alertes) au LandingScreenContainer.
 */

export default function LandingConsumerPage() {
  const { parcelId } = useParams();

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'PRD') return;
    track('app_entry', { props: { entry_type: parcelId ? 'qr_scan' : 'home' } });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LandingPageProvider>
      <LandingScreenContainer />
    </LandingPageProvider>
  );
}
